import { Component, inject, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { first } from "rxjs/operators";
import { AssetRulesService } from "src/app/services/asset-rules/asset-rules.service";
import { RuleFilterComponent } from "../rule-filter/rule-filter.component";
@Component({
	selector: "app-assign-rule",
	templateUrl: "./assign-rule.component.html",
	styleUrls: ["./assign-rule.component.scss"],
})
export class AssignRuleComponent implements OnInit {
	constructor(public dialogRef: MatDialogRef<AssignRuleComponent>, private assetRuleService: AssetRulesService) {}

	@ViewChild(RuleFilterComponent, { static: true }) ruleFilter;
	data = inject<string>(MAT_DIALOG_DATA);
	selectedRuleId: string = null;
	ngOnInit(): void {}

	confirmAssignRule() {
		this.assetRuleService.confirmAssignRule$.next(this.selectedRuleId);
		this.dialogRef.close();

		this.dialogRef
			.afterClosed()
			.pipe(first())
			.subscribe(_ => {
				this.ruleFilter.clearSelectedOptions();
				this.selectedRuleId = null;
				this.assetRuleService.confirmAssignRule$.next(this.selectedRuleId);
			});
	}

	cancelClick() {
		this.dialogRef.close();
		this.assetRuleService.confirmCancelAssignRule$.next();

		this.dialogRef
			.afterClosed()
			.pipe(first())
			.subscribe(_ => {
				this.ruleFilter.clearSelectedOptions();
				this.selectedRuleId = null;
				this.assetRuleService.confirmCancelAssignRule$.next();
			});
	}

	getRuleId(ids: string[]) {
		this.selectedRuleId = ids[0];
	}
}
